try {
    if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');
    else require('./index.css');
  } catch (e) {
    if (e.code !== 'MODULE_NOT_FOUND') {
      throw e; // Re-throw unexpected errors
    }
    console.warn('index.css / index-new.css not found, proceeding without it.');
  }


import { jsx } from 'react/jsx-runtime';
import React, { forwardRef, Suspense } from 'react';
import classNames from 'classnames';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

const FluidGridCentred$1 = React.lazy(() => Promise.resolve().then(function () { return fixedCentred; }));
const FluidGridStart$1 = React.lazy(() => Promise.resolve().then(function () { return fixedStart; }));
const FluidGridStandard$1 = React.lazy(() => Promise.resolve().then(function () { return fluid; }));
const FluidGrid = forwardRef((_a, ref) => {
    var { variant } = _a, componentProperties = __rest(_a, ["variant"]);
    switch (variant) {
        case 'fluid':
            return (jsx(Suspense, Object.assign({ fallback: jsx("div", { children: "..." }) }, { children: jsx(FluidGridStandard$1, Object.assign({ ref: ref }, componentProperties)) })));
        case 'fixed-centered':
            return (jsx(Suspense, Object.assign({ fallback: jsx("div", { children: "..." }) }, { children: jsx(FluidGridCentred$1, Object.assign({ ref: ref }, componentProperties)) })));
        case 'fixed-start':
            return (jsx(Suspense, Object.assign({ fallback: jsx("div", { children: "..." }) }, { children: jsx(FluidGridStart$1, Object.assign({ ref: ref }, componentProperties)) })));
        default:
            return null;
    }
});

const FluidGridCentred = forwardRef((_a, ref) => {
    var { className, tag: Tag = 'div', preferredCardSize, children } = _a, htmlProperties = __rest(_a, ["className", "tag", "preferredCardSize", "children"]);
    return (jsx(Tag, Object.assign({ ref: ref, style: { '--fluid-grid-card-size': `${preferredCardSize}px` }, className: classNames('cds-fluid-grid-centred', className) }, htmlProperties, { children: children })));
});

var fixedCentred = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': FluidGridCentred
});

const FluidGridStart = forwardRef((_a, ref) => {
    var { className, tag: Tag = 'div', preferredCardSize, children } = _a, htmlProperties = __rest(_a, ["className", "tag", "preferredCardSize", "children"]);
    return (jsx(Tag, Object.assign({ ref: ref, style: { '--fluid-grid-card-size': `${preferredCardSize}px` }, className: classNames('cds-fluid-grid-start', className) }, htmlProperties, { children: children })));
});

var fixedStart = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': FluidGridStart
});

const FluidGridStandard = forwardRef((_a, ref) => {
    var { className, tag: Tag = 'div', preferredCardSize, cardsPerRow, children } = _a, htmlProperties = __rest(_a, ["className", "tag", "preferredCardSize", "cardsPerRow", "children"]);
    return (jsx(Tag, Object.assign({ ref: ref, style: {
            '--fluid-grid-card-size': `${preferredCardSize}px`,
            '--fluid-grid-card-number': cardsPerRow,
        }, className: classNames('cds-fluid-grid-standard', className) }, htmlProperties, { children: children })));
});

var fluid = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': FluidGridStandard
});

export { FluidGrid };
